/**
 * DrawingPanel — Drawing and annotation tools (map wired via useDrawingInteraction)
 */
import React, { useEffect } from 'react';
import { Box, Typography } from '@mui/material';
import DrawingToolsPanel from '../../DrawingToolsPanel';
import TextAnnotationDialog from '../../TextAnnotationDialog';
import { useAppDispatch } from '../../../store/hooks';
import { setMeasurementMode } from '../../../store/slices/measurementSlice';
import { tokens } from '../../../theme';
import { useGeoveraTheme } from '../../../theme/ThemeContext';

const DrawingPanel: React.FC = () => {
  const dispatch = useAppDispatch();
  const { palette } = useGeoveraTheme();

  useEffect(() => {
    // Measure and draw share the map — clear measure when drawing
    dispatch(setMeasurementMode(null));
  }, [dispatch]);

  return (
    <Box sx={{ p: 1 }}>
      <Typography
        sx={{
          fontSize: tokens.fontSize.sm,
          color: palette.text.secondary,
          px: 0.5,
          pb: 1,
          lineHeight: 1.45,
        }}
      >
        Choose a tool, then click on the map. Save drawings as a layer when finished.
      </Typography>
      <DrawingToolsPanel />
      <TextAnnotationDialog />
    </Box>
  );
};

export default DrawingPanel;
